import React from 'react';
import logo from '../../../common/assets/tol-logo-text.jpg';
import { LandingPageTypes } from '../../../common/helpers/domain/landingPages';
import { getLandingPageMeta } from '../../../common/helpers/ui/pageTitleMetaDescription';
import SeoHeader from '../../seoHeader/SeoHeader';

interface HomeSeoHeaderProps {
  pageType: LandingPageTypes;
  canonicalLink: string;
}

function HomeSeoHeader({ pageType, canonicalLink }: HomeSeoHeaderProps) {
  const pageMeta = getLandingPageMeta(pageType);

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: pageMeta.schemaName,
    description: pageMeta.schemaDescription,
    publisher: {
      '@type': 'organization',
      name: 'Thinkofliving',
    },
    url: canonicalLink,
  };

  return (
    <>
      <SeoHeader
        title={pageMeta.title}
        description={pageMeta.description}
        canonicalLink={canonicalLink}
        imageUrl={logo}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </>
  );
}

export default HomeSeoHeader;
